import { Story } from '../../DocTypes';

export const leftAndRightItemsStory: Story = {
  title: 'Left and right items',
  description: 'List with items having text on the left and right',
  coreComponent: {
    html: `<tag-list
    left-icon='Badge2'
    left-icon-accent='atoll'
    primary-field='name'
    left-label-1='Number:' left-field-1='number'
    right-label-1='Age:' right-field-1='age'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { number: 1, name: 'Jordan Pickford', age: '24' },
      { number: 2, name: 'Kyle Walker', age: '27' },
      { number: 5, name: 'John Stones', age: '23' },
      { number: 6, name: 'Harry Maguire', age: '25' },
      { number: 7, name: 'Luke Shaw', age: '25' }
    ]);
  });
    `,
  },
  // coreComponent_v3: {
  //   html: `<tag3-list
  //   left-icon='Badge2'
  //   left-icon-accent='atoll'
  //   primary-field='name'
  //   left-label-1='Number:' left-field-1='number'
  //   right-label-1='Age:' right-field-1='age'>
  // </tag3-list>`,
  //   js: `var tagList = document.querySelector('tag3-list');
  //   tagList.setData([
  //     { number: 1, name: 'Jordan Pickford', age: '24' },
  //     { number: 2, name: 'Kyle Walker', age: '27' },
  //     { number: 5, name: 'John Stones', age: '23' },
  //     { number: 6, name: 'Harry Maguire', age: '25' },
  //     { number: 7, name: 'Luke Shaw', age: '25' }
  //   ]);
  //   `,
  // },
  reactWrapper: {
    jsx: `<TagList
    leftIcon='Badge2'
    leftIconAccent='atoll'
    primaryField='name'
    leftLabel1='Number:'
    leftField1='number'
    rightLabel1='Age:'
    rightField1='age'
    data={[
      { number: 1, name: 'Jordan Pickford', age: '24' },
      { number: 2, name: 'Kyle Walker', age: '27' },
      { number: 5, name: 'John Stones', age: '23' },
      { number: 6, name: 'Harry Maguire', age: '25' },
      { number: 7, name: 'Luke Shaw', age: '25' }
    ]}
  />`,
  },
};
